<template>
  <vs-popup classContent="popup-example" :title="popTitle" :active.sync="popupActive" buttonCloseHidden>
    <slot name="body">

    </slot>
  </vs-popup>
</template>


<script>
  export default {
    name: 'popup',
    props: {
      activePopup: {
        type: Boolean,
        default: false,
      },
      popTitle: {
        type: String,
        default: '',
      }
    },
    data () {
      return {
        popupActive: false,
      }
    },
    watch: {
      activePopup(newVal) {
        this.popupActive = newVal;
      },
    },
    mounted() {
      this.popupActive = this.activePopup;
    }
  }
</script>
